import { useEffect, useState } from 'react';
import { VariableSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import Loading from '@/components/shared/Loading';
import TransferTx from './TransferTx';
import Transaction from './Transaction';
import { useHistoryFiltersQuery } from '@/hooks/history/useHistoryFilters';
import { useSession } from '@/contexts/LitSessionProvider';
import { useOrderHistory } from '@/hooks/db/useOrderHistory';
import SlidingModal from '../SlidingModal';
import TransactionViewTransfer from '../../shared/TransactionViewTransfer';
import TransactionView from '../../shared/TransactionView';
interface Props {
  orderHistoryOverride?: any;
  orderId?: string;
}
export default function MobileHistory(p: Props) {
  const {
    PKP
  } = useSession();
  const solanaAddress = PKP?.solanaAddress;
  const ethAddress = PKP?.additionalEthAddress;
  const {
    data: mainOrderHistoryData,
    isLoading: orderHistoryLoading
  } = useOrderHistory({
    cloudWallet: PKP?.additionalEthAddress,
    solanaAddress: PKP?.solanaAddress
  });
  const mainOrderHistory = p.orderHistoryOverride || mainOrderHistoryData;
  const {
    data: filters
  } = useHistoryFiltersQuery();
  const [filteredTrades, setFilteredTrades] = useState<any>(mainOrderHistory?.data);
  const [todayTrades, setTodayTrades] = useState<any>([]);
  const [lastWeekTrades, setLastWeekTrades] = useState<any>([]);
  const [lastMonthTrades, setLastMonthTrades] = useState<any>([]);
  const [restOfTrades, setRestOfTrades] = useState<any>([]);
  const [modalData, setModalData] = useState<{
    isTransfer: boolean;
    txItem: any;
  } | null>(null);
  useEffect(() => {
    if (p.orderId) {
      const trade = mainOrderHistory?.data.find(trade => trade.id === Number(p.orderId));
      if (trade) {
        setModalData({
          isTransfer: false,
          txItem: trade
        });
      }
    }
  }, [mainOrderHistory, p.orderId]);
  useEffect(() => {
    if (mainOrderHistory?.data && filters) {
      const now = new Date();
      const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const startOfWeek = new Date(now.setDate(now.getDate() - now.getDay()));
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const filtered = mainOrderHistory.data.filter(trade => {
        const _isTransfer = trade?.type === 'withdraw' || trade?.type === 'deposit';
        const _isReceived = _isTransfer ? ethAddress === trade?.to_address || solanaAddress === trade?.to_address : false;
        const receivedMatch = filters.txTypeFilter === 'received' ? _isReceived : true;
        const sendMatch = filters.txTypeFilter === 'send' ? _isTransfer && !_isReceived : true;
        const swapMatch = filters.txTypeFilter === 'swap' ? !_isTransfer : true;
        // Apply filters for network, status, and token as before
        const matchesNetwork = filters.network ? _isTransfer ? filters.network?.includes(trade.chain_id) : filters.network?.includes(trade.token_prices?.tokensIn[0]?.network) || filters.network?.includes(trade.token_prices?.tokensOut[0]?.network) : true;
        const matchesStatus = filters.txStatusFilter && filters.txStatusFilter !== 'all' ? trade.result.decodedResponse.status === filters.txStatusFilter : true;
        const tokenMatch = filters.tokenFilter && _isTransfer ? filters.tokenFilter?.token_address === trade.token_address && filters.tokenFilter?.network === trade.chain_id : false;
        const tokenInMatch = filters.tokenFilter && !_isTransfer ? filters.tokenFilter?.token_address === trade.token_prices?.tokensIn[0]?.contract_address && filters.tokenFilter?.network === trade.token_prices?.tokensIn[0]?.network : false;
        const tokenOutMatch = filters.tokenFilter && !_isTransfer ? filters.tokenFilter?.token_address === trade.token_prices?.tokensOut[0]?.contract_address && filters.tokenFilter?.network === trade.token_prices?.tokensOut[0]?.network : false;
        const matchedToken = !filters.tokenFilter ? true : _isTransfer ? tokenMatch : tokenInMatch || tokenOutMatch;

        // Time filter logic
        let matchesTime = true;
        const tradeDate = new Date(trade.created_at);
        if (filters.txTimeFilter !== 'all') {
          switch (filters.txTimeFilter) {
            case 'today':
              matchesTime = tradeDate >= startOfToday;
              break;
            case 'week':
              matchesTime = tradeDate >= startOfWeek;
              break;
            case 'month':
              matchesTime = tradeDate >= startOfMonth;
              break;
              matchesTime = true;
              break;
          }
        }
        if (filters.txTimeFilter !== 'all') {
          switch (filters.txTimeFilter) {
            case 'today':
              matchesTime = tradeDate >= startOfToday;
              break;
            case 'week':
              matchesTime = tradeDate >= startOfWeek;
              break;
            case 'month':
              matchesTime = tradeDate >= startOfMonth;
              break;
              matchesTime = true;
              break;
          }
        }
        return matchesNetwork && matchesStatus && matchedToken && matchesTime && receivedMatch && sendMatch && swapMatch;
        // return matchesNetwork && receivedMatch && sendMatch && swapMatch;
      });

      // Categorize based on time
      const todayTrades = filtered.filter(trade => new Date(trade.created_at) >= startOfToday);
      const lastWeekTrades = filtered.filter(trade => new Date(trade.created_at) >= startOfWeek && new Date(trade.created_at) < startOfToday);
      const lastMonthTrades = filtered.filter(trade => new Date(trade.created_at) >= startOfMonth && new Date(trade.created_at) < startOfMonth);
      const restOfTrades = filtered.filter(trade => new Date(trade.created_at) < startOfMonth);

      // Update state with categorized trades
      setFilteredTrades(filtered);
      setTodayTrades(todayTrades);
      setLastWeekTrades(lastWeekTrades);
      setLastMonthTrades(lastMonthTrades);
      setRestOfTrades(restOfTrades);
    } else {
      setFilteredTrades(mainOrderHistory?.data);
    }
  }, [mainOrderHistory, filters]);
  if (orderHistoryLoading) {
    return <div className='h-[80vh] w-full flex flex-col items-center justify-center'>
        <Loading />
      </div>;
  }
  if (!filteredTrades || filteredTrades.length === 0) {
    return <p className='h-[80vh] text-genius-cream text-center w-full flex items-center justify-center text-lg'>
        No transaction history
      </p>;
  }
  const allTradesEmpty = todayTrades.length === 0 && lastWeekTrades.length === 0 && lastMonthTrades.length === 0;
  const groupedTrades = [];
  if (allTradesEmpty) {
    groupedTrades.push(...filteredTrades);
  } else {
    if (todayTrades.length > 0) {
      groupedTrades.push({
        type: 'header',
        label: 'Today'
      }, ...todayTrades);
    }
    if (lastWeekTrades.length > 0) {
      groupedTrades.push({
        type: 'header',
        label: 'Last Week'
      }, ...lastWeekTrades);
    }
    if (lastMonthTrades.length > 0) {
      groupedTrades.push({
        type: 'header',
        label: 'Last Month'
      }, ...lastMonthTrades);
    }
    if (restOfTrades.length > 0) {
      groupedTrades.push({
        type: 'header',
        label: 'All Time'
      }, ...restOfTrades);
    }
  }
  return <>
      <AutoSizer data-sentry-element="AutoSizer" data-sentry-source-file="MobileHistory.tsx">
        {({
        height,
        width
      }) => <List key={`${groupedTrades.length}-${filters?.txTypeFilter}-${filters?.txStatusFilter}-${filters?.txTimeFilter}-${filters?.network}-${filters?.tokenFilter}`} height={height} itemCount={groupedTrades.length} itemSize={index => {
        return groupedTrades[index].type === 'header' ? 30 : 70;
      }} width={width} className='no-scrollbar' style={{
        paddingBottom: '80px'
      }}>
            {({
          index,
          style
        }) => {
          const item = groupedTrades[index];
          const _isTransfer = item?.type === 'withdraw' || item?.type === 'deposit';
          return <div style={style}>
                  {item.type === 'header' ? <p className='text-[16px] text-genius-cream/50 ml-4 mt-2'>{item.label}</p> : _isTransfer ? <TransferTx txItem={item} index={index} setModalData={setModalData} /> : <Transaction txItem={item} index={index} setModalData={setModalData} />}
                </div>;
        }}
          </List>}
      </AutoSizer>

      <SlidingModal isOpen={modalData !== null} onClose={() => setModalData(null)} heightFit data-sentry-element="SlidingModal" data-sentry-source-file="MobileHistory.tsx">
        {modalData?.isTransfer ? <TransactionViewTransfer txItem={modalData?.txItem} toggleModal={() => setModalData(null)} isModalOpen={modalData !== null} /> : <TransactionView txItem={modalData?.txItem} />}
      </SlidingModal>
    </>;
}